import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';

export default class SubscribeModal extends Modal {
	oninit(vnode) {
		super.oninit(vnode);
		this.loading = false;
		this.canceling = false;
		this.reactivating = false;
	}

	className() {
		return 'StripeSubscribeModal Modal--small';
	}

	title() {
		const isActive = this.attrs.currentStatus?.status === 'active';
		return isActive ? 'Funder Subscription' : 'Become a Funder';
	}

	content() {
		const { priceLabel, description, currentStatus, totalSpent = 0 } = this.attrs;
		const isActive = currentStatus?.status === 'active';

		// Format cents to a dollar string
		const formatAmount = (cents) => (cents / 100).toFixed(2);

		const isCanceled = !!currentStatus?.ends_at;
		const expiryDate = currentStatus?.ends_at
			? new Date(currentStatus?.ends_at).toLocaleDateString()
			: null;

		if (isActive) {
			return (
				<div className="Modal-body">
				<div className="Alert Alert--success" style="margin-bottom:16px">
				<span className="fas fa-check-circle" style="margin-right:6px" />
				{isCanceled
					? `Subscription expires ${expiryDate} and will not renew. You will keep access to all characters.`
					: `Your subscription is active and renews on ${expiryDate}.`
				}
				</div>

				{totalSpent > 0 && (
					<div className="Form-group" style="margin-bottom:16px">
					<label>Total contributed</label>
					<div className="helpText" style="font-size:1.1em;font-weight:600">
					{formatAmount(totalSpent) + "€"}
					</div>
					</div>
				)}

				<div className="Form-group" style="margin-top:20px">
				{isCanceled ? (
					<Button
					className="Button Button--primary Button--block"
					loading={this.reactivating}
					disabled={this.reactivating}
					onclick={this.reactivateSubscription.bind(this)}
					>
					{this.reactivating ? 'Processing...' : 'Resume Subscription'}
					</Button>
				) : (
					<Button
					className="Button Button--danger Button--block"
					loading={this.canceling}
					disabled={this.canceling}
					onclick={this.cancelSubscription.bind(this)}
					>
					{this.canceling ? 'Processing...' : 'Unsubscribe'}
					</Button>
				)}
				</div>
				</div>
			);
		}

		return (
			<div className="Modal-body">
			{description && <p style="margin-bottom:16px">{description}</p>}

			<div className="Form">
			<div className="Form-group">
			<label>Plan</label>
			<div className="helpText">{priceLabel || 'Monthly subscription'}</div>
			</div>

			{app.forum.attribute('kemze-stripe.testMode') && (
				<div className="Alert" style="margin-bottom:12px;font-size:0.85em">
				<strong>Test mode active.</strong> Use card <code>4242 4242 4242 4242</code>,
				any future expiry, any CVC.
				</div>
			)}

			<div className="Form-group" style="margin-top:20px">
			<Button
			className="Button Button--primary Button--block"
			loading={this.loading}
			disabled={this.loading}
			onclick={this.submit.bind(this)}
			>
			{this.loading ? 'Redirecting...' : 'Continue to payment'}
			</Button>
			</div>
			</div>
			</div>
		);
	}

	cancelSubscription() {
		if (!confirm('Are you sure you want to cancel funding?')) return;

		this.canceling = true;
		m.redraw();

		app.request({
			method: 'POST',
			url: `${app.forum.attribute('apiUrl')}/stripe/cancel`,
		})
			.then(() => {
				this.canceling = false;
				app.modal.close();
				app.alerts.show({ type: 'success' }, 'Your subscription has been cancelled.');
				window.location.reload();
			})
			.catch(() => {
				this.canceling = false;
				m.redraw();
				app.alerts.show({ type: 'error' }, 'Could not cancel subscription. Please try again.');
			});
	}
	reactivateSubscription() {
		if (!confirm('Resume your subscription? You will continue to be billed monthly.')) return;

		this.reactivating = true;
		m.redraw();

		app.request({
			method: 'POST',
			url: `${app.forum.attribute('apiUrl')}/stripe/reactivate`,
		})
			.then(() => {
				this.reactivating = false;
				app.modal.close();
				app.alerts.show({ type: 'success' }, 'Your subscription has been resumed.');
				window.location.reload();
			})
			.catch(() => {
				this.reactivating = false;
				m.redraw();
				app.alerts.show({ type: 'error' }, 'Could not resume subscription. Please try again.');
			});
	}

	submit() {
		this.loading = true;
		m.redraw();

		app.request({
			method: 'POST',
			url: `${app.forum.attribute('apiUrl')}/stripe/checkout`,
			body: {
				type: 'subscription',
				price_id: this.attrs.priceId,
				quantity: 1,
			},
		})
			.then(result => {
				window.location.href = result.url;
			})
			.catch(() => {
				this.loading = false;
				m.redraw();
				app.alerts.show({ type: 'error' }, 'Payment failed to start. Please try again.');
			});
	}
}
